module.exports = __webpack_public_path__ + "media/images/badge/campionato-finalista_secondary-d42d4946183e183200054b964dfc09ca.png";